import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/contexts';
import Loading from '../components/common/Loading';
import ErrorBoundary from './ErrorBoundary';

const ProtectedRoute = ({ children, requireAdmin }) => {
  const { currentUser, userRole, loading } = useAuth();
  const location = useLocation();

  // Show loading state while authentication is being checked
  if (loading) {
    return <Loading />;
  }

  // Not authenticated
  if (!currentUser) {
    return <Navigate 
      to="/signin" 
      state={{ 
        from: location,
        error: {
          status: 401,
          message: 'Please sign in to access this page.'
        }
      }} 
      replace 
    />;
  }

  // Check for admin route access
  if (requireAdmin && userRole !== 'admin') {
    return <ErrorBoundary 
      error={{
        status: 403,
        message: 'You do not have permission to access this page.'
      }}
    />;
  }

  // Check for user-only route access
  if (location.pathname === '/user' && userRole === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default ProtectedRoute; 